import { PAGAMENTO_PREMIACAO_ERROR, PremiacaoState, PremiacaoActionTypes, PremiacaoError } from "domain/types/_carteira/premiacao/premiacao";

const INITIAL_STATE: PremiacaoState = {
  Errors: []
};

export function PremiacaoReducer(
  state = INITIAL_STATE,
  action: PremiacaoActionTypes
): PremiacaoState {
  switch (action.type) {
    case PAGAMENTO_PREMIACAO_ERROR:
      return { 
        ...state, 
        Errors: action.payload ? [...state.Errors, action.payload as PremiacaoError] : state.Errors 
      };
    default:
      return state;
  }
}